import React from 'react'
import NewArival from '../components/newArival'
import Navbar from '../components/navbar'
import UseSearch from '../hooks/useSearch'

interface Product{
    category:Number
    created_at:Date
    description:string
    id:string
    images:{ image: string }[]
    name:string
    owner:Number
    price:string
    image:string
    
    }

function Shop() {
    const {data,getData} = UseSearch()
  return (
    <div>
    <Navbar/>
    <div style={{marginTop:70}}>
    <NewArival/>
    </div>
    </div>
  )
}

export default Shop
